import { sendExportRequest, type PerformanceWithAccountFilter } from "features/Library/Common/utils/performanceUtils";
import {
  getLicensesAccountPacksExport,
  getLicensesAccountsExport,
  getLicensesPacksOverviewExport,
} from "../../services/packsLicensingReportingService";

let abortController = new AbortController();

export const doLicensesAccountPacksExport = (filterParams: PerformanceWithAccountFilter, name: string) => {
  return sendExportRequest(
    (abortController) => getLicensesAccountPacksExport(filterParams, abortController.signal),
    name,
    abortController,
  );
};

export const doLicensesAccountsExport = (filterParams: PerformanceWithAccountFilter, name: string) => {
  return sendExportRequest(
    (abortController) => getLicensesAccountsExport(filterParams, abortController.signal),
    name,
    abortController,
  );
};

export const doLicensesPacksOverviewExport = (filterParams: PerformanceWithAccountFilter, name: string) => {
  return sendExportRequest(
    (abortController) => getLicensesPacksOverviewExport(filterParams, abortController.signal),
    name,
    abortController,
  );
};
